/**
 *  AenaTerminalsAccordion script file
**/
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  name: 'app-aenaTerminalsAccordion',
  mixins: [],
  components: {
    VuePerfectScrollbar
  },
  props: {
    data: {
      type: [Object, Array],
      required: true
    },
    type: {
      type: String,
      required: true
    },
    active: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      activeItem: this.type,
      activeSubItem: this.active
    }
  },
  mounted () {
    this.updateScroll()
  },
  computed: {
    terminals () {
      return this.data.terminals.items
    },
    parkings () {
      return this.data.parkings.items
    }
  },
  methods: {
    toggle (item) {
      this.activeItem = item
      this.activeSubItem = undefined
      this.$emit('onToggle', item)
      this.updateScroll()
    },
    select (item) {
      this.activeSubItem = item.name
      this.$emit('onItemSelected', item)
    },
    updateScroll () {
      setTimeout(() => {
        this.$refs.scrollbar.update()
        this.$refs.scrollbar.scrollTo(0, 0)
      }, 360)
    },
    enter (element) {
      element.style.height = 'auto'
      const height = getComputedStyle(element).height
      element.style.height = 0
      // eslint-disable-next-line
      window.getComputedStyle(element).height
      setTimeout(() => {
        element.style.height = height
        this.updateScroll()
      })
    },
    afterEnter (element) {
      element.style.height = 'auto'
    },
    leave (element) {
      const height = getComputedStyle(element).height
      element.style.height = height
      // eslint-disable-next-line
      window.getComputedStyle(element).height
      setTimeout(() => { element.style.height = 0 })
    }
  },
  watch: {
    type (value) {
      this.activeItem = value
    },
    active (value) {
      this.activeSubItem = value
    }
  }
}
